/**
 *    @author:
 *    @since:
 *
 */

import { Component, HostListener, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData, AboutChild, ParentInfo } from '../_common/data/input-data';
import { GAData, Path, Progress } from  "../_common/constant/page-const";
import { AboutTheChildMainValidation } from './about_the_child_main.validator';
import { ItemList } from '../_common/constant/item-list';
import { Code, Confirm } from 'src/refresh/service/constant';
import { ViewportScroller } from '@angular/common';
import { LightBox } from 'src/refresh/layout/light-box/light-box.component';
import { Util } from 'src/refresh/service/Util';
import { ProgressService } from 'src/refresh/service/progress-service';
import { CommonService } from 'src/refresh/service/common-service';

@Component({ 
      selector: 'about_the_child_main',
      templateUrl: './about_the_child_main.component.html',
      styleUrls: ['./about_the_child_main.component.less']
})
export class AboutTheChildMainComponent extends FormBaseComponent implements OnInit {

      public aboutChild: AboutChild;
      public parents:ParentInfo[];
      public parentCount:number;
      public certyfyingCount:number;
      public isSurrogate:boolean;
      public isUnableToCertify:boolean;
      public isCustodyOtherThanParent:boolean;
      public childNameParam:Object;
      ///public namesLength: number;
      public deliveredByOther: boolean;
      public isOpenCSN:boolean = false;
      public isOpenASN:boolean = false;

       //errors
      public errorLastName = new Array();
      public error_childFirstName: string = "";
      public error_childMiddleName: string = "";
      public error_childLastName: string = "";
      public error_parentsAgree: string = "";
      public error_gender: string = "";
      public error_childs_weight: string = "";
      public error_childs_birth_order: string = "";
      public error_childs_city_town: string = "";
      public error_childs_place: string = "";
      public error_hospital: string = "";
      public error_birthingCentre: string = "";
      public error_streetNumber: string = "";
      public error_streetNameRuralRoute: string = "";
      public error_streetNameRuralRouteIntersection: string = "";
      public error_attendentType: string = "";
      public error_parentCurLastName: string = "";
      public error_nextParentCurLastName: string = "";
      public error_childSingleName: string = "";
      public error_parentsAgreeSN: string = "";
      public error_otherCity: string = "";
      public error_otherHospital: string = "";
      public error_otherBirthingCentre: string = "";
      public error_attendantFirstName: string = "";
      public error_attendantLastName: string = "";
      public error_attendantSingleName: string = "";
      public error_attendentTitle: string = "";
      public error_deliveredByOther: string = "";
      public error_deliveredByOtherHospital: string = "";
      
      public hospitalList:Map<string,string>;
      public birthingCentreList:Map<string,string>;
      ///public p  = new Array();
      @ViewChild(LightBox) box: LightBox;
      isOpened:boolean = false;
      
       constructor( protected router: Router,
                    public timerService:TimerService,
                    protected progress:ProgressService,
                    public items:ItemList,
                    public data:InputData,
                    public viewportScroller: ViewportScroller,
                    private commonService: CommonService ) {

                    super(router,timerService);  
                    super.setNextPage(Path.AboutTheChildScreen2,Path.Setup5);
                    super.setValidator(new AboutTheChildMainValidation(this, viewportScroller, data.aboutChild, Progress.AboutChild));

                    this.aboutChild = data.aboutChild;

                    this.initErrors();
                    this.setLocalFieldFromData(data);

                    this.setParentLastName();

                    this.setBirthOrder();

                    if ( this.parentCount == 1 || this.isCustodyOtherThanParent )
                         this.aboutChild.isParentAgreeOnLastName = "";

                    if( this.aboutChild.isParentAgreeOnLastName == Confirm.NO )
                        this.aboutChild.name.last = this.setLastName();

                    this.commonService.getCloseLightBox().subscribe((r) =>{
                        if(this.isOpened) this.onMyClose();
                    });

                    if ( this.data.isNextChild ) {
                        window.onpopstate = function () {
                               window.history.go(1);
                               window.history.pushState(null, null, window.location.href);
                        }
                        window.history.pushState(null, null, window.location.href);
                    }

                    InputData.currentPageIdx = 8;
                    if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       // when navigated back from parent page with single name checked.
       // @see onNextClick() to revert
       private setParentLastName() {

              if( this.aboutChild.isParentAgreeOnLastName == Confirm.NO ){
                  for ( let i = 0; i < this.parentCount; i++ ) {
                        if ( this.parents[i].name.chk_singleName == Confirm.YES ) {
                             this.parents[i].name.last = this.parents[i].name.single;
                             this.parents[i].name.single = '';
                        }
                  }
              }
       }

       public setBirthOrder() {
              if ( this.data.eligibility.birthType == '1' ) 
                   this.aboutChild.birthOrder = '1';
       }

       public onNextClick() : boolean {
              
            if( this.aboutChild.isParentAgreeOnLastName == Confirm.NO ){
                  for ( let i = 0; i < this.parentCount; i++ ) {
                        if ( this.parents[i].name.chk_singleName == Confirm.YES ) {
                             this.parents[i].name.single = this.parents[i].name.last;
                             this.parents[i].name.last = '';
                        }
                  }
            }

           if ( super.onNextClick() ) {
                  if ( this.data.isNextChild ) {
                        window.onpopstate = function () {
                        }
                   }
                   return true;
           }
           return false;
       }


       private setLocalFieldFromData(data:InputData) {
            this.parents = data.parents;
            this.isSurrogate = data.eligibility.isBornThroughSurrogacy=='Y';
            this.isUnableToCertify = data.eligibility.isUnableToCertify=='Y';
            this.isCustodyOtherThanParent = data.eligibility.isCustodyOtherThanParent=='Y';
            this.deliveredByOther = data.eligibility.deliveredByOther=='Y';

            if ( this.isUnableToCertify ) {
                 if(data.eligibility.listedParentCount > 2){
                    this.parentCount = data.eligibility.certifyingParentCount;
                    this.parents = this.parents.slice(0,this.parentCount);
                 } else {
                    this.parentCount = 1;
                 }
            } 
            else {
                this.parentCount = data.eligibility.listedParentCount;
            }

           if(this.data.aboutChild.pounds || this.data.aboutChild.ounces){
                  this.poundsOunces=true;
                  this.grams = false;
           } else {
                  this.poundsOunces=false;
                  this.grams = true;
           }

           this.setBirthCenterList();
       }
      
       private initErrors() {
             this.errorLastName = new Array<String>(this.parentCount);
             for ( let i = 1; i < this.parentCount; i++ )
                   this.errorLastName[i] = "";
       }

       public critical: boolean = false;

       public checknamesLength(){
              return this.aboutChild.name.last.length > 50;
              /**
            if(this.parentCount==2 &&  this.namesLength > 49){
                  return true;
           } else if (this.parentCount==3 &&  this.namesLength > 48){
                  return true;
           } else if (this.parentCount==4 &&  this.namesLength > 47) {
                  return true;
           } else {
                  this.critical = false
           }
            */
       }

      
       public parentsNameLength(event: any, n: any){
            /**
            this.p[n] = event.target.value.length;
            let temp = 0;
            for (let i = 0; i < this.parentCount; i++) {
                  temp += this.p[i];
            }
            this.namesLength = temp;
             */

            this.aboutChild.name.last = this.setLastName();

            this.checknamesLength()
       }
      
       public  isParentAgreeChange() {
             
            if(this.aboutChild.isParentAgreeOnLastName === 'Y'){

                  /**
                  if ( this.aboutChild.name.last && 
                       this.aboutChild.name.last == this.setLastName() )
                       this.aboutChild.name.last = '';
                  */
 
                  if ( !this.data.isNextChild ) {
                        this.parents[0].name.last = "";
                  }
                  this.error_parentCurLastName = "";
                  if(this.parentCount>1){
                  for ( let i = 1; i < this.parentCount; i++ ){
                        if ( !this.data.isNextChild ) {
                              this.parents[i].name.last = "";
                        }
                        this.errorLastName[i] = "";
                        }
                  }else {
                        this.initErrors();
                  }
            }
            else
               this.aboutChild.name.last = '';
       }

       private setLastName():string {
            let lastName = "";
            let parentNames = new Array();
            for ( let i = 0; i < this.parentCount; i++ ){
                  let parentName = this.parents[i].name.last.trim();
                  if ( parentName )
                       parentNames.push(parentName);  
            }

            const distinctparentNames = parentNames.filter((value, index, self) => {
                  return self.indexOf(value) === index});

            distinctparentNames.sort();

             for ( let i = 0; i < distinctparentNames.length; i++ ){
                  lastName += distinctparentNames[i];
                  if(distinctparentNames[i + 1]){
                        lastName += "-";
                  }
             }      

             return lastName;
      }

      public getFullName():string  {
            if ( this.aboutChild.name.chk_singleName == 'Y' ) {
                 return this.aboutChild.name.single;
            }

            let fullName = '';
            if(this.aboutChild.isParentAgreeOnLastName === 'N') 
                 fullName = this.setLastName();
            else fullName = this.aboutChild.name.last;
            
            if ( this.aboutChild.name.middle ) fullName = this.aboutChild.name.middle + " " + fullName;
            if ( this.aboutChild.name.first  ) fullName = this.aboutChild.name.first  + " " + fullName;

            return fullName;
     }

     public completed():boolean{
            if ( this.aboutChild.name.last && this.aboutChild.name.first ) return true;
            if ( this.aboutChild.name.single ) return true;
            if ( this.parentCount ==2 && this.parents[0].name.last && this.parents[1].name.last) return true;
            if ( this.parentCount ==3 && this.parents[0].name.last
                   && this.parents[1].name.last
                   && this.parents[2].name.last) return true;
            if ( this.parentCount ==4 && this.parents[0].name.last
                  && this.parents[1].name.last
                  && this.parents[2].name.last
                  && this.parents[3].name.last) return true;
            return false;
      }

      public onSingleNameChange() {

            if( this.aboutChild.name.chk_singleName !='Y' ) {
                  this.aboutChild.name.single = "";
                  this.aboutChild.isParentAgreeOnSingleName = "";
            }
            else {
                  //isParentAgreeOnSingleName value is required on final review page.
                  this.aboutChild.isParentAgreeOnSingleName = Confirm.YES;
                  this.aboutChild.isParentAgreeOnLastName = "";
                  this.aboutChild.name.clear();
            } 

          this.isOpenCSN = true;
          this.error_childFirstName  = "";    
          this.error_childMiddleName = "";    
          this.error_childLastName   = "";
          this.aboutChild.name.last = "";    
          this.error_childLastName   = "";   
          this.error_parentsAgree = ""; 

          if ( this.parentCount > 1 ) {
             for (let i = 0; i < this.parentCount; i++) {
                  this.parents[i].name.last = ""; 
             }
          }
     }

     public onAttendantSingleNameChange(){

             this.aboutChild.attendentSingleName = "";
             this.aboutChild.attendentLastName = "";
             this.aboutChild.attendentFirstName = "";
 
             this.isOpenASN = true;
             this.error_attendantFirstName  = "";    
             this.error_attendantLastName = ""; 
             this.error_attendantSingleName = ""; 
     }

     public onAttendentChange(){
            this.error_attendantFirstName  = "";
            this.error_attendantLastName = "";
            this.error_attendantSingleName = "";
            this.aboutChild.attendentFirstName = "";
            this.aboutChild.attendentLastName = "";
            this.aboutChild.attendentSingleName = "";
            this.aboutChild.attendentTitle = "";
            this.error_attendentTitle = "";
            this.aboutChild.isDoctorSingleName='N';
            this.aboutChild.isMidwifeSingleName='N';
            this.aboutChild.isSomeoneElseSingleName='N';
            this.error_deliveredByOther = "";
            this.isOpenASN = false;
     }

       public ngOnInit() {
            if ( super.forwardNext(InputData.currentPageIdx) ) {
                 if ( this.data.pushed() ) this.data.pop();
                 return;      
            }
            
            if ( this.data.pushed() ) {
                 this.viewportScroller.scrollToAnchor(this.data.pop());
            }
       }

      poundsOunces:boolean=false;
      grams:boolean=true;

      gramsPounds(){
            this.poundsOunces=true;
            this.grams=false;

            this.aboutChild.grams = undefined;
            this.error_childs_weight = "";
            super.gtag(GAData.Link,GAData.switch_pounds);
        }

      poundsGrams(){
            this.poundsOunces=false;
            this.grams=true;
            this.aboutChild.pounds = undefined;
            this.aboutChild.ounces = undefined;
            this.error_childs_weight = "";
            
        }

        setBirthCenterList() {
            let city = this.aboutChild.cityTown;
            
            let  idx = city.lastIndexOf("_");
            if ( idx > 0 ) city = city.substring(idx+1);
            this.hospitalList = this.items.hospitalList[city];
            if ( !this.hospitalList )  {
                  this.hospitalList = new Map<string,string>();
                  this.hospitalList.set(Code.NotFound,this.items.NotFoundDesc);
            }

            this.birthingCentreList = this.items.birthCenterList[city];
            if ( !this.birthingCentreList )  {
                  this.birthingCentreList = new Map<string,string>();
                  this.birthingCentreList.set(Code.NotFound,this.items.NotFoundDesc);
            }
        }

        cityChange() {
            this.setBirthCenterList();
            this.error_otherCity = "";
            this.aboutChild.birthPlaceCode = "";
            this.aboutChild.otherBirthPlace = "";
        }

         birthPlacesChange(){
               this.aboutChild.birthPlaceCode = "";
               this.aboutChild.otherBirthPlace = "";
               this.aboutChild.birthStreetNumber = "";
               this.aboutChild.birthStreetName = "";
               this.error_deliveredByOtherHospital = "";
               this.error_hospital = "";
               this.error_birthingCentre = "";
               this.error_streetNumber = "";
               this.error_streetNameRuralRoute  = "";
               this.error_streetNameRuralRouteIntersection = "";
               this.error_otherHospital = "";
               this.error_otherBirthingCentre ="";
         }

      onMyClick(event: MouseEvent) {
            event.preventDefault();
            this.box.open();
            this.isOpened = true;
       }
      
       onMyClose() { 
            this.box.close();
            this.isOpened = false;
       }   

       goORGContact() {
             this.data.push("parentNameInput");
             this.router.navigate([Path.ORGContactInformation]);  
       }

       public onCancelApplication() {
               super.cancelApplication(this.data);
       }
       
       @HostListener('document:keydown.escape', ['$event'])
       public escape(){
             if(this.isOpened) {
                   this.onMyClose();
             }
      }

      public onStreetNumber() {

            setTimeout( () => {
                  this.aboutChild.birthStreetNumber = this.aboutChild.birthStreetNumber.trim();
                  if ( Util.isEmpty(this.aboutChild.birthStreetNumber) == false ) {
                  
                        let list = this.aboutChild.birthStreetNumber.split(' ');

                        if ( list.length > 1 ) {

                              let name = this.aboutChild.birthStreetNumber.substring(list[0].length+1).trim();
                              this.aboutChild.birthStreetNumber = list[0];

                              if ( Util.isEmpty(this.aboutChild.birthStreetName) ) {
                                   this.aboutChild.birthStreetName = name;
                              }
                        }
                  }
            },1);
     }

}